'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _code = require('./code');

var _code2 = _interopRequireDefault(_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warning = 'The `Code` component relies on `react-syntax-highlighter` ' + 'package. Please install it via the package manager.';

// Use warning as a fallback
var Code = function Code() {
  return _react2.default.createElement('code', null, warning);
};

try {
  var highlight = require('react-syntax-highlighter/prism');
  Code = (0, _code2.default)(highlight.default);
} catch (_) {
  // show additional warning in the console
  console.warn(warning);
}

exports.default = Code;